module.exports = __webpack_public_path__ + "static/media/jet2.bc67578b.png";